import React from "react";
import TripInput from "../../components/trip-input/TripInput";
import NewTripNav from "../../components/navbar/newtrip-nav/NewTripNav";
import dayjs from "dayjs";
import "./NewTrip.css";

function Trips() {
  const emptyTrip = {
    TRIP_NAME: "",
    DESTINATION: "",
    START_DATE: dayjs(),
    END_DATE: dayjs()
  }
  return (
    <div className="trips-page">
      <NewTripNav />
      <TripInput postRoute={"https://tripmate-rbck.onrender.com/trip-saved"} initialData={emptyTrip} />
    </div>
  );
}

export default Trips;
